






























































import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import t from '@/utils/tools'

export default {
    name: 'balance'

    props:
        user_uid:
            type: String
            required: true
        reload:
            type: Boolean
            required: false
        can_save:
            type: Boolean
            required: true

    watch:
        user_uid: (new_uid, old_uid)->
            if new_uid != ''
                @get_balance()
        reload: (new_reload, old_reload)->
            if new_reload != old_reload and @user_uid != ''
                @get_balance()

    data: ()->
        loading: true
        min: 0
        precision: 2
        show_cols: false
        show_rows: false
        days_col_label: 'Jours / Heures posés'
        rh_col_label: 'Solde RH'
        all_rows: ['leave_n_1', 'leave_n', 'seniority_leave', 'extra_leave_1', 'extra_leave_2', 'total_leave', 'rtt', 'rco', 'rcr', 'total_rc', 'cet', 'break_days']
        condensed_rows: ['total_leave', 'rtt', 'total_rc', 'cet', 'break_days']
        search: []
        width_button_text: "Afficher toutes les colonnes"
        height_button_text: "Afficher toutes les lignes"
        balance_save: {
            uid: ''
            user_uid: ''
            modified: ''
            leave_n_1: {
                acquired: 0.0
                taken: 0.0
            }
            leave_n: {
                acquired: 0.0
                taken: 0.0
            }
            seniority_leave: {
                acquired: 0.0
                taken: 0.0
            }
            extra_leave_1: {
                acquired: 0.0
                taken: 0.0
            }
            extra_leave_2: {
                acquired: 0.0
                taken: 0.0
            }
            total_leave: {
                acquired: 0.0
                taken: 0.0
            }
            rtt: {
                acquired: 0.0
                taken: 0.0
            }
            rco: {
                acquired: 0.0
                taken: 0.0
            }
            rcr: {
                acquired: 0.0
                taken: 0.0
            }
            total_rc: {
                acquired: 0.0
                taken: 0.0
            }
            cet: {
                acquired: 0.0
                taken: 0.0
            }
            break_days: {
                acquired: 0.0
                taken: 0.0
            }
        }
        balance_array: []
        label_mapping: {
            leave_n_1: 'Congés payés - année n-1'
            leave_n: 'Congés payés - année n'
            seniority_leave: 'Congés payés - ancienneté'
            extra_leave_1: 'Congés payés - sup 1'
            extra_leave_2: 'Congés payés - sup 2'
            total_leave: 'Congés payés'
            rtt: 'RTT'
            rco: 'Repos Compensateur Obligatoire'
            rcr: 'Repos Compensateur de Remplacement'
            total_rc: 'Repos Compensateur'
            cet: 'Compte Épargne Temps'
            break_days: 'Repos forfait jour'
        }

    computed:
        data_filtered: ()->
            self = @
            data = @balance_array.filter (x) ->
                x.label in self.search
            return data

        width_icon_class: ()->
            class_str = 'fa fa-expand'
            if @show_cols
                class_str = 'fa fa-compress'
            return class_str

        height_icon_class: ()->
            class_str = 'fa fa-expand'
            if @show_rows
                class_str = 'fa fa-compress'
            return class_str

    methods:
        toggle_width: ()->
            if @show_cols
                @show_cols = false
                @width_button_text = "Afficher les colonnes"
            else
                @show_cols = true
                @width_button_text = "Masquer les colonnes"

        toggle_height: ()->
            if @show_rows
                @show_rows = false
                @search = @condensed_rows
                @height_button_text = "Afficher les lignes"
            else
                @show_rows = true
                @search = @all_rows
                @height_button_text = "Masquer les lignes"

        human_label: (label)->
            return @label_mapping[label]

        array_span_method: ({ row, column, rowIndex, columnIndex })->
            if column.label == @days_col_label or column.label == @rh_col_label
                if row.label == 'leave_n_1'
                    return [3, 1]
                else if row.label in ['leave_n', 'seniority_leave']
                    return [0, 0]

        cell_class_name: ({ row, column, rowIndex, columnIndex })->
            if columnIndex == 0 and row.label in @condensed_rows
                return 'bold'

        reset_balance_array: ()->
            @balance_array = [
                {
                    label: 'leave_n_1'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'leave_n'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'seniority_leave'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'extra_leave_1'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'extra_leave_2'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'total_leave'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'rtt'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'rco'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'rcr'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'total_rc'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'cet'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                },
                {
                    label: 'break_days'
                    acquired: 0.0
                    taken: 0.0
                    wage_balance: 0.0
                    validated_days: 0.0
                    rh_balance: 0.0
                }
            ]
            return

        reset_balance_save: ()->
            @balance_save = {
                uid: ''
                user_uid: ''
                modified: ''
                leave_n_1: {
                    acquired: 0.0
                    taken: 0.0
                }
                leave_n: {
                    acquired: 0.0
                    taken: 0.0
                }
                seniority_leave: {
                    acquired: 0.0
                    taken: 0.0
                }
                extra_leave_1: {
                    acquired: 0.0
                    taken: 0.0
                }
                extra_leave_2: {
                    acquired: 0.0
                    taken: 0.0
                }
                total_leave: {
                    acquired: 0.0
                    taken: 0.0
                }
                rtt: {
                    acquired: 0.0
                    taken: 0.0
                }
                rco: {
                    acquired: 0.0
                    taken: 0.0
                }
                rcr: {
                    acquired: 0.0
                    taken: 0.0
                }
                total_rc: {
                    acquired: 0.0
                    taken: 0.0
                }
                cet: {
                    acquired: 0.0
                    taken: 0.0
                }
                break_days: {
                    acquired: 0.0
                    taken: 0.0
                }
            }
            return

        reset_icon: ()->
            @width_button_text = "Afficher toutes les colonnes"
            @height_button_text = "Afficher toutes les lignes"
            @show_cols = false
            @show_rows = false
            return

        get_balance: ()->
            self = @
            @loading = true
            q.run('get_balance', [@user_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error('balance: get_balance: then', e.message)
                else
                    # console.log "GET balance : ", resp.body.data.balance
                    self.search = self.condensed_rows
                    self.reset_icon()
                    tmp_balance = resp.body.data.balance
                    if resp.body.data.balance.uid != null
                        self.balance_save = t.deep_copy(resp.body.data.balance)
                        delete tmp_balance.uid
                        delete tmp_balance.modified
                        self.balance_array = Object.values(tmp_balance)
                        # console.log "BALANCE ", self.balance_save.uid
                        # console.log "BALANCE ARRAY ", self.balance_array
                    else
                        self.reset_balance_array()
                        self.reset_balance_save()
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "balance: get_balance()")

        save: ()->
            # console.log "SAVE BALANCE", @balance
            self = @
            @balance_save.user_uid = @user_uid
            if @can_save
                m.run('save_balance', [@balance_save])
                .then (resp)->
                    if resp.body.data.balance_form_mutation.form_ret == 'failed'
                        return n.access_denied()
                    if resp.body.data.balance_form_mutation.errors.length > 0
                        n.error("balance: save()", "Erreur")
                    else
                        self.get_balance()
                        self.$emit('new-balance')
                        n.success()
                .catch (resp)->
                    n.catch_error(resp, "balance: save()")
            
    beforeMount: ()->
        # console.log "BALANCE CAN SAVE", @can_save
        # console.log "BALANCE USER", @user_uid
        if @user_uid not in ['', 'undefined']
            @get_balance()
}
